import {
    createObjectField,
    createPrimitiveField,
    type InferFieldValue,
    type ValidationError,
} from '@adv-frontend/form-kit';

export const fieldClient = createObjectField({
    fields: {
        firstName: createPrimitiveField({ defaultValue: '' }),
        lastName: createPrimitiveField({ defaultValue: '' }),
        email: createPrimitiveField({ defaultValue: '' }),
        phone: createPrimitiveField({ defaultValue: '' }),
    },
    selectors: {
        getIsFilled: (client) => Boolean(client.firstName && client.lastName && client.phone && client.email),
    },
    validators: (createValidators) =>
        createValidators<
            ValidationError<
                | 'REQUIRED_CLIENT'
                | 'INVALID_NAME_FORMAT'
                | 'INVALID_EMAIL_FORMAT'
                | 'INVALID_PHONE_FORMAT'
                | 'REQUIRED_PHONE_VERIFICATION'
            >
        >(),
});

export type ClientFieldValue = InferFieldValue<typeof fieldClient>;
